const api = {
  listRefundOrders: '/order/listRefundOrdersInStore',   // 商家退款单列表
  getRefundOrder: '/order/getRefundOrder',              // 退款单详情
  approveRefund: '/order/approveRefund',                  // 商家端同意退款（营销）
  declineRefund: '/order/declineRefund',                // 商家端驳回退款（营销）
  exportRefundOrders: '/order/exportRefundOrders',      // 导出退款单
};

const routes = {
	'/refund-manage': '退款售后',
	'/refund-manage/detail': '退款详情',
};

export {
	api,
	routes,
};
